// src/services/api/bulkProductSettings.js
import { apiClient } from './base';

const NAMESPACE = 'bulkProduct';

export const getBulkProductSettings = async () => {
  try {
    const response = await apiClient.get(`/business-settings/${NAMESPACE}`);
    return response.data.settings || {};
  } catch (error) {
    throw error;
  }
};

export const saveBulkProductSettings = async (settings) => {
  try {
    const response = await apiClient.put(`/business-settings/${NAMESPACE}`, { settings });
    return response.data.settings;
  } catch (error) {
    throw error;
  }
};
